import React from 'react';
import cn from 'classnames';
import styles from "./ProgressBar.module.scss";
export const ProgressBar = props => {
  const {
    completed,
    total,
    variant = 'steps'
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.progressBar, styles[variant + 'Variant'])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.progressThumb,
    style: {
      width: 100 * completed / total + '%'
    }
  }));
};